import {NgOptimizedImage} from "@angular/common";
import {Component} from "@angular/core";
import {Navbar} from "../../layout/navbar/navbar";
import {NewsCards} from "../news/news-card/news-cards";
import {ProjectSlider} from "../projects/project-slider/project-slider";
import {ServicesBlock} from "../services/services-block/services-block";

interface SlideshowImage {
  readonly id: number;
  readonly image: string;
  readonly alt: string;
}

@Component({
  selector: "app-home",
  templateUrl: "./home.html",
  styleUrl: "./home.scss",
  imports: [
    NgOptimizedImage,
    Navbar,
    ServicesBlock,
    ProjectSlider,
    NewsCards,
  ],
})
export default class Home {
  protected readonly images: readonly SlideshowImage[] = [
    {
      id: 1,
      image: "assets/images/slideshow-1432501.webp",
      alt: $localize`Blutdruck Log`,
    },
    {
      id: 2,
      image: "assets/images/slideshow-1432667.webp",
      alt: $localize`iLosungen`,
    },
    {
      id: 3,
      image: "assets/images/slideshow-1432658.webp",
      alt: $localize`Telekom Kundencenter App`,
    },
  ];

  protected scrollTo(element: HTMLElement): void {
    element.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
  }
}
